import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import useSession from '@/hooks/use-session';
import { loadImageAsDataUrl } from './load-image-as-data-url';
const useTenantLogo = enabled => {
  const $ = _c(12);
  const {
    data: t0
  } = useSession();
  const {
    org
  } = t0;
  const hasLogo = Boolean(org?.logoUrl);
  const t1 = org?.logoUrl;
  let t2;
  if ($[0] !== t1) {
    t2 = ["pdf-export", "tenant-logo", t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== org?.logoUrl) {
    t3 = async () => {
      const dataUrl = await loadImageAsDataUrl(org?.logoUrl ?? "");
      if (!dataUrl) {
        throw new Error("Tenant logo failed to load");
      }
      return dataUrl;
    };
    $[2] = org?.logoUrl;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = enabled && hasLogo;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: Number.POSITIVE_INFINITY,
      retry: 1
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data,
    isFetched
  } = useQuery(t5);
  const t6 = org?.name;
  const t7 = data ?? undefined;
  const t8 = !hasLogo || isFetched;
  let t9;
  if ($[8] !== t6 || $[9] !== t7 || $[10] !== t8) {
    t9 = {
      tenantName: t6,
      tenantLogoSrc: t7,
      isReady: t8
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
export default useTenantLogo;